const categoryRouter = [
  {
      path: "list-sample",
      name: "sample",
      component: () => import("@/views/admin/sample_license"),
      default: true,
      meta: {
          model: "sample_license",
          // requiresAuth: true,
      },
  },
  {
      path: "list-sample/add",
      name: "addSampleLicense",
      component: () => import("@/views/admin/sample_license/function"),
      default: true,
      meta: {
          model: "sample_license",
          // requiresAuth: true,
      },
  },
  {
      path: "list-sample/edit/:id",
      name: "editSampleLicense",
      component: () => import("@/views/admin/sample_license/function"),
      default: true,
      meta: {
          model: "sample_license",
          // requiresAuth: true,
      },
  }
]
export default categoryRouter;